import { render, staticRenderFns } from "./NoShowTreatmentDetails.vue?vue&type=template&id=4e37fd9a"
import script from "./NoShowTreatmentDetails.vue?vue&type=script&lang=js"
export * from "./NoShowTreatmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports